import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Params } from '@angular/router';
import { WA_LOCAL_STORAGE } from '@ng-web-apis/common';
import type { ProfileType, VerticalType } from '@rma/common-ui-domain/types';
import { RmaUrlsService } from '@rma/generic/util/environment';
import { httpParamMapper } from '@rma/generic/util/http';
import { Observable } from 'rxjs';
import { ContactRequest } from '../domain/contact';
import { FindMyAgentRequest, FindMyAgentResponse } from '../domain/results';

const FIND_MY_RESULTS = 'FIND_MY_RESULTS';

@Injectable({
  providedIn: 'root',
})
export class FindMyAgentService {
  private readonly httpClient = inject(HttpClient);
  private readonly localStorage = inject<Storage>(WA_LOCAL_STORAGE);
  private readonly rmaUrls = inject(RmaUrlsService);

  public getAgents(request: FindMyAgentRequest): Observable<FindMyAgentResponse[]> {
    return this.httpClient.get<FindMyAgentResponse[]>(this.rmaUrls.apiUrl('finder', 'FindMyAgent'), {
      params: httpParamMapper(request),
    });
  }

  public contact(verticalType: VerticalType, profileType: ProfileType, profileCode: string, request: ContactRequest): Observable<number> {
    return this.httpClient.post<number>(this.rmaUrls.apiUrl(`contact/${verticalType}/${profileType}/code-${profileCode}`, 'FindMyAgent'), {
      ...request,
    });
  }

  public save<T>(criteria: T): void {
    this.localStorage.setItem(FIND_MY_RESULTS, JSON.stringify(criteria));
  }

  public restore(): Params | undefined {
    const results = this.localStorage.getItem(FIND_MY_RESULTS);

    if (results) {
      return JSON.parse(results);
    }

    return undefined;
  }

  public clear(): void {
    this.localStorage.removeItem(FIND_MY_RESULTS);
  }
}
